import { Pill } from "@/components/podkit/status/Pill";
import { Text } from "@/components/podkit/typography/Text";
import type { PlainWorkflowTrigger } from "@/queries/automation-queries";
import { pullRequestEventName, triggerName } from "@/utils/automations";
import type { FC } from "react";
import { WorkflowTriggerContext } from "@/components/automations/AutomationTriggerContext";

type WorkflowTriggerConfigurationProps = {
    trigger: PlainWorkflowTrigger;
};

export const WorkflowTriggerConfiguration: FC<WorkflowTriggerConfigurationProps> = ({ trigger }) => {
    return (
        <div className="flex items-center gap-2">
            <Text className="text-sm font-medium">{triggerName(trigger)}</Text>
            {trigger.trigger.case === "pullRequest" &&
                trigger.trigger.value.events.map((event, index) => (
                    <Pill key={index} variant="info" size={"sm"}>
                        On: {pullRequestEventName(event)}
                    </Pill>
                ))}
            <WorkflowTriggerContext trigger={trigger} />
        </div>
    );
};
